class Description extends HTMLElement {
  constructor() {
    super();
    this._onMore = this._onMore.bind(this);
    this._onLess = this._onLess.bind(this);
  }

  connectedCallback() {
    this.moreBtn = this.querySelector('.description-more');
    this.lessBtn = this.querySelector('.description-less');
    this.fullEl = this.querySelector('.description-full');

    if (this.moreBtn) this.moreBtn.addEventListener('click', this._onMore);
    if (this.lessBtn) this.lessBtn.addEventListener('click', this._onLess);

    // Initial sicherstellen
    if (this.fullEl) {
      this.fullEl.style.height = '0px';
      this.fullEl.style.opacity = '0';
    }
  }

  disconnectedCallback() {
    if (this.moreBtn) this.moreBtn.removeEventListener('click', this._onMore);
    if (this.lessBtn) this.lessBtn.removeEventListener('click', this._onLess);
  }

  _onMore() {
    if (!this.fullEl) return;

    // Erst expand state setzen (damit opacity etc. greift)
    this.classList.add('is-expanded');

    // Height animieren von 0 -> scrollHeight
    this.fullEl.style.height = '0px'; // reset
    const target = this.fullEl.scrollHeight;

    requestAnimationFrame(() => {
      this.fullEl.style.height = `${target}px`;
      this.fullEl.style.opacity = '1';
    });

    // Nach Transition auf "auto" setzen, damit bei Responsive/Font-Changes nix abschneidet
    const onEnd = (e) => {
      if (e.propertyName !== 'height') return;
      this.fullEl.style.height = 'auto';
      this.fullEl.removeEventListener('transitionend', onEnd);
    };
    this.fullEl.addEventListener('transitionend', onEnd);
  }

  _onLess() {
    if (!this.fullEl) return;

    // Von auto -> px zurück, dann zu 0 animieren
    const current = this.fullEl.scrollHeight;
    this.fullEl.style.height = `${current}px`;
    this.fullEl.style.opacity = '1';

    requestAnimationFrame(() => {
      this.fullEl.style.height = '0px';
      this.fullEl.style.opacity = '0';
    });

    const onEnd = (e) => {
      if (e.propertyName !== 'height') return;
      this.classList.remove('is-expanded');
      this.fullEl.removeEventListener('transitionend', onEnd);
    };
    this.fullEl.addEventListener('transitionend', onEnd);
  }
}

//customElements.define('text-with-more-button', Description);
